<template>
  <div class="help-wrap">
    <div class="help-card">
      <div class="title">常见问题</div>
      <div class="q-list-wrap" v-html="detail.content">
        <!-- <div class="item">
          <div class="serial">01</div>
          <div class="question-answer">
            <div class="question">小程序的奖励类型有哪些？</div>
            <div class="answer">积分、余额、经验 。</div>
          </div>
        </div>
        <div class="item">
          <div class="serial">02</div>
          <div class="question-answer">
            <div class="question">积分有什么用？</div>
            <div class="answer">积分可以在“我的积分”中兑换余额，也可以在“积分商城”里兑换奖品。</div>
          </div>
        </div>
        <div class="item">
          <div class="serial">03</div>
          <div class="question-answer">
            <div class="question">积分怎么兑换奖励？</div>
            <div class="answer">在“积分商城”中选择需要兑换的奖励，填写收货地址即可。</div>
          </div>
        </div>
        <div class="item">
          <div class="serial">04</div>
          <div class="question-answer">
            <div class="question">余额有什么用？</div>
            <div class="answer">可以直接提现。提现申请审核通过后，会在 5 个工作日内到账。</div>
          </div>
        </div>
        <div class="item">
          <div class="serial">05</div>
          <div class="question-answer">
            <div class="question">经验有什么用？</div>
            <div class="answer">可以升级账号等级。账号等级越高，所能获得的优惠权益越大。</div>
          </div>
        </div>
        <div class="item">
          <div class="serial">06</div>
          <div class="question-answer">
            <div class="question">用户提交的信息审核（身份认证、体现审核、申请成为工作人员) 多就能完成？</div>
            <div class="answer">3个工作日</div>
          </div>
        </div>
        <div class="item">
          <div class="serial">07</div>
          <div class="question-answer">
            <div class="question">实名认证和身份认证有什么用？</div>
            <div class="answer">
              一个实名认证只能绑定一个账号；<br>
              身份认证之后，可以申请成为工作人员，以此来获得奖励；<br>
              未完成实名和身份认证无法使用积分和余额功能
            </div>
          </div>
        </div> -->
      </div>
      <div class="tip">
        部分功能可能存在缺陷，用户可以在“我的”—“其他功能”中进行反馈，我们确认后有精美礼品哦！如果因为小程序的问题对您的合理权益有影响，请您及时联系客服解决，为此我们深感抱歉！
      </div>
    </div>
  </div>
</template>

<script>

import { getPageDetail } from "@/api/page";
export default {
  name: 'UserFaq',
  components: {

  },
  data() {
    return {
      loading: true,
      detail: {},
    };
  },
  computed: {

  },
  created() {
    this.getPageDetail();
  },
  methods: {
    getPageDetail() {
      getPageDetail({ alias: 'faq' }).then(res => {
        this.loading = false;
        this.detail = res.data;
      }).catch((err) => {

      });
    },
  }
};
</script>

<style lang="scss" scoped>
.help-wrap {
  width: 100%;

  .help-card {
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 1px rgba(111, 127, 132, 0.102);
    border-radius: 2px;
    margin-top: 16px;
    padding-bottom: 70px;

    .title {
      width: 100%;
      border-bottom: 1px solid #CCD7DB;
      padding: 29px 0;
      font-size: 16px;
      font-weight: bold;
      color: #222222;
      text-align: center;
    }

    .q-list-wrap {
      width: 100%;
      padding: 20px 68px 0 68px;
      box-sizing: border-box;
      display: flex;
      // align-items: center;
      flex-direction: column;
      row-gap: 25px;

      .item {
        display: flex;
        column-gap: 9px;
        width: 100%;

        .serial {
          font-size: 16px;
          font-weight: 300;
          color: #A7ACB2;
          text-decoration: dashed;
        }

        .question-answer {
          display: flex;
          flex-direction: column;
          row-gap: 10px;
          width: 100%;

          .question {
            font-size: 16px;
            font-weight: bold;
            color: #222222;
          }

          .answer {
            font-size: 16px;
            font-weight: 300;
            color: #222222;
            line-height: 28px;
            padding-bottom: 10px;
            border-bottom: 1px solid #a0a9ac3a;
          }
        }
      }
    }

    .tip {
      width: 100%;
      padding: 0 95px;
      font-size: 16px;
      font-weight: 400;
      color: #6F7F84;
      line-height: 28px;
      margin-top: 28px;
    }
  }
}</style>
